<template>
  <div class="account-moderator-candidates">
    <div class="account-moderator-candidates__head">
      <h1 class="account-moderator-candidates__title">{{ $tModeratorCandidates('Candidates') }}</h1>
    </div>

    <SubpagesTabs :routes="tabsRoutes"
                  class="account-moderator-candidates__tabs  _grey">
      <transition name="fade"
                  mode="out-in">
        <router-view></router-view>
      </transition>
    </SubpagesTabs>
  </div>
</template>

<script>
  import SubpagesTabs from '@/components/SubpagesTabs'

  export default {
    name: 'AccountModeratorCandidatesPage',
    components: {
      SubpagesTabs
    },
    data() {
      return {}
    },
    computed: {
      tabsRoutes() {
        return [{
          id: 1,
          name: this.$tModeratorCandidates('Resumes'),
          route: {name: 'account-moderator-candidates-resumes'}
        }, {
          id: 2,
          name: this.$tModeratorCandidates('Resumes base'),
          route: {name: 'account-moderator-candidates-resumes-base'}
        }, {
          id: 3,
          name: this.$tModeratorCandidates('On interaction'),
          route: {name: 'account-moderator-candidates-on-interaction'}
        }]
      }
    }
  }
</script>

<style lang="less">

</style>
